import React, { useContext } from "react";
export var ConfigContext = /*#__PURE__*/ React.createContext({
    googleClientId: undefined,
    host: undefined,
    segmentApiKey: undefined
});
export function useConfig() {
    return useContext(ConfigContext);
}
